<template>
  <div id="app" ref="app">
    <router-view/>
  </div>
</template>
<script>
export default {
  name: "app",
};
</script>

<style lang="scss">
  @import './scss/_globals.scss';
</style>
